import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const ContentWrap = styled.div`
  flex: 1;
  margin-top: 70px;
`;

export const DivContenedor = styled.div`
  background-color: #fff;
  margin-left: 10%;
  margin-right: 10%;
  padding: 20px;
  border-radius: 10px;
`;

export const ButtonActualizar = styled.button`
  padding: 10px 20px;
  background-color: #99c800;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
  &:hover {
    background-color: #2b8d41;
  }
`;

export const Row = styled.div`
  display: flex;
  gap: 100px;
  margin-bottom: 10px;
`;

export const DivForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
